import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgForOf} from "@angular/common";
import {forEach, includes, isEqual, sortBy, uniq} from 'lodash-es';
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {CommonWidgetDirective} from "@wms/directives";

@Component({
  standalone: true,
  selector: 'wms-classpicker',
  templateUrl: './classpicker.component.html',
  styleUrls: ['./classpicker.component.less'],
  imports: [FormsModule, NgForOf, BsDropdownModule, CommonWidgetDirective]
})
export class WMSClasspickerComponent {
  @Input() value! : string;
  @Input() property! : string;
  @Input() widgetId! : string;
  @Input() options! : string[];
  widgetClasses! : { name : string; checked : boolean; }[];
  @Output() onFocus! : EventEmitter<any>;
  @Output() onChange! : EventEmitter<{name : string, prop : string}>;
  @Input() sortOptions : boolean = true;

  /**
   * Add delimiter and class
   * @param widgetClass
   * @param delimiter
   */
  addClass(widgetClass : string, delimiter : string) {
    return delimiter + widgetClass;
  }

  /**
   * Remove widgetClass from appliedClasses
   * @param widgetClasses
   * @param widgetClass
   */
  removeClass(widgetClasses : string, widgetClass : string) {
    let appliedClasses = widgetClasses ? widgetClasses.split(' ') : [];
    appliedClasses.splice(appliedClasses.indexOf(widgetClass), 1);
    return appliedClasses.join(' ');
  }

  /**
   * Prepare list picker dropdown options
   * @param allClasses
   * @param appliedClasses
   */
  prepareOptions(allClasses : string[], appliedClasses : string[]) : { name : string; checked : boolean; }[] {
    let optionClasses = uniq(appliedClasses.concat(allClasses));
    let options: { name : string; checked : boolean; }[] = [];
    let checked;
    forEach(optionClasses, (widgetClass : string) => {
      if (widgetClass) {
        checked = includes(appliedClasses, widgetClass);
        options.push({ 'name' : widgetClass, 'checked' : checked });
      }
    });
    return this.sortOptions ? sortBy(options, option => option?.name) : options;
  }

  /**
   * Handle input event of list picker input element and emit focus event
   */
  onInput() : void {
    this.onFocus.emit();
  }

  /**
   * Set the selected class and emit change event
   */
  setWidgetClass() : void {
    let appliedClasses = this.value ? this.value.split(' ') : [];
    this.widgetClasses = this.prepareOptions(this.options, appliedClasses);
    this.onChange.emit({name : this.property, prop : this.value});
  }

  /**
   * Handle the list picker dropdown toggle and call setWidgetClass
   * @param widgetClass
   */
  toggleClass(widgetClass : { name : string; checked : boolean; }) : void {
    if (widgetClass.checked){
      this.value = this.value ? this.value.trim() : '';
      this.value += this.value ? this.addClass(widgetClass.name, ' ') : this.addClass(widgetClass.name, '');
    }
    else {
      this.value = this.removeClass(this.value, widgetClass.name);
      this.value = this.value.trim();
    }
    this.setWidgetClass();
  }
  trackByFn(index : number, widgetClass : { name : string; checked : boolean; }) {
    return index;
  }
  updateWidgetClasses() {
    let appliedClasses = this.value ? this.value.split(' ') : [];
    this.widgetClasses = this.prepareOptions(this.options, appliedClasses);
  }
  constructor() {
    this.onFocus = new EventEmitter<any>();
    this.onChange = new EventEmitter<{name : string, prop : string}>();
  }
  ngOnInit() {
    this.options = this.options || [];
    this.updateWidgetClasses();
  }
  ngOnDestroy() {
    this.updateWidgetClasses();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['options'] && !isEqual(changes['options'].previousValue, changes['options'].currentValue)) ||
      (changes['value'] && !isEqual(changes['value'].previousValue, changes['value'].currentValue))) {
      this.updateWidgetClasses();
    }
  }
}
